export const getContactNameFromContact = (contact) => {
  if (!contact) {
    return '-'
  }

  if (contact.firstname && contact.lastname) {
    return `${contact.firstname} ${contact.lastname}`
  }

  if (contact.lastname) {
    return contact.lastname
  }

  if (contact.firstname) {
    return contact.firstname
  }

  if (contact.name) {
    return contact.name
  }

  return '-'
}

